
import { path, map } from "ramda";
import { mapState } from "vuex";

export default {
  props: {
    feel: { type: String, default: "" },
    scales: { type: Array, default: () => [] },
    scaleSide: { type: String, default: "" },
  },

  computed: {
    ...mapState(["siteConfig"]),
    comfortFeel() {
      return path(["pdp", "comfortFeel"], this.siteConfig);
    },
    getComfortLevels() {
      return map(x => path([x], this.comfortFeel));
    },
    desktopComfortLevels() {
      return this.getComfortLevels(path(["desktop"], this.comfortFeel));
    },
    // mobileComfortLevels() {
    //   const feels = path(["mobile"], this.comfortFeel);

    //   const isMediumPlushScale = this.scale >= 3;

    //   return isMediumPlushScale
    //     ? this.getComfortLevels(feels.mediumPlush)
    //     : this.getComfortLevels(feels.firmMedium);
    // },
  },
};
